import { render } from "./SetView.vue?vue&type=template&id=fc0244b6&scoped=true"
import script from "./SetView.vue?vue&type=script&lang=js"
export * from "./SetView.vue?vue&type=script&lang=js"

import "./SetView.vue?vue&type=style&index=0&id=fc0244b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0244b6"]])

export default __exports__